import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const SRUSD_URL = 'https://app.reservoir.xyz/api/website'

const srUsd = 'Reservoir srUSD::SRUSD'
const wsrusd = 'Wrapped Savings rUSD::WSRUSD'

export const srusdFetcher: YieldFetcher = {
  label: 'SRUSD',
  fetch: async () => {
    const res = await fetch(SRUSD_URL, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    }).then((r) => r.json())
    const apr = apyToAprPercent(Number(res?.srusdApy ?? 0))
    return {
      [srUsd]: apr,
      [wsrusd]: apr,
    }
  },
}
